import { createStore } from "vuex";
import axios from "axios";

export default createStore({
    state: {
        token: localStorage.getItem("token") || null,
        userData: null,
        tahunAjaran: JSON.parse(localStorage.getItem("taAktif")),
        defaultLimit: 10,
    },
    getters: {
        getToken(state) {
            return state.token;
        },
        getUserData(state) {
            return state.userData;
        },
        getTahunAjaran(state) {
            return state.tahunAjaran;
        },
        getDefaultLimit(state) {
            return state.defaultLimit;
        },
    },
    mutations: {
        setToken(state, value) {
            state.token = value;
            localStorage.setItem("token", value);
        },
        setUserData(state, data) {
            state.userData = data;
        },
        setTahunAjaran(state, ta) {
            state.tahunAjaran = ta;
        },
        setDefaultLimit(state, limit) {
            state.defaultLimit = limit;
        },
    },
    actions: {
        updateToken({ commit }, data) {
            commit("setToken", data);
        },
        authenticateUser({ commit }, auth) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        auth + "/info",
                        {},
                        { headers: { Authorization: this.state.token } }
                    )
                    .then((response) => {
                        commit("setUserData", response.data.user);
                        resolve();
                    })
                    .catch((error) => {
                        commit("setToken", null);
                        commit("setUserData", null);
                        reject(error);
                    });
            });
        },
        logoutUser({ commit }) {
            localStorage.removeItem("token");
            commit("setUserData", null);
            commit("setToken", null);
        },
        fetchTahunAjaran({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        "/list/tahun-ajaran",
                        {},
                        { headers: { Authorization: this.state.token } }
                    )
                    .then((response) => {
                        const tahunAjaran = response.data.tahun_ajaran.filter(
                            (ta) => ta.ppdb_aktif
                        );
                        commit("setTahunAjaran", tahunAjaran[0]);
                        localStorage.setItem(
                            "taAktif",
                            JSON.stringify(tahunAjaran[0])
                        );
                        resolve();
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        updateDefaultLimit({ commit }, batasBaris) {
            commit("setDefaultLimit", batasBaris);
        },
    },
    modules: {},
});
